import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { processGeotaggedImage } from './geotaggedUtils';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import SideBar from './SideBar';
import axios from 'axios';
import axiosConn from '../../config/axiosConn';
import baseURL from '../../config/configRoutes.js';
import './RasActivitiesForm.css';

import stateList from '../../helper/State_List.json';
import districtList from '../../helper/District_List.json';

// Removed CSS that hides the calendar/time icon for datetime-local input

// Add these styles at the top of the file (or inside the component if using hooks)
const dropdownStyle = {
  fontSize: '1.08em',
  fontWeight: 500,
  padding: '8px 16px', // Less vertical padding for better centering
  height: '48px',      // Fixed height for consistent centering
  border: '2px solid #b2dfdb',
  borderRadius: 8,
  background: '#f9fbe7',
  color: '#222',
  outline: 'none',
  marginBottom: 16,
  boxShadow: '0 2px 8px #0001',
  transition: 'border-color 0.2s, box-shadow 0.2s',
  width: '50%',
  boxSizing: 'border-box',
  appearance: 'none',
};
const inputStyleAll = {
  fontSize: '1.08em',
  fontWeight: 500,
  padding: '12px 16px',
  border: '2px solid #b2dfdb',
  borderRadius: 8,
  background: '#fffde7',
  color: '#222',
  outline: 'none',
  marginBottom: 16,
  boxShadow: '0 2px 8px #0001',
  transition: 'border-color 0.2s, box-shadow 0.2s',
  width: '50%',
  boxSizing: 'border-box'
};

// Utility to convert UTC to IST
function utcToIst(utcString) {
  if (!utcString) return '';
  const date = new Date(utcString.replace(/-/g, ':').replace('T', ' ').replace('Z', ''));
  // Add 5 hours 30 minutes
  date.setHours(date.getHours() + 5);
  date.setMinutes(date.getMinutes() + 30);
  return date.toLocaleString('en-IN', { hour12: false });
}


// Load state and district data from JSON files

const getDistrictsByStateId = (stateId) => {
  return districtList.filter(d => d.state_id === stateId);
};

// Helper to get state_id from state_name
const getStateIdByName = (name) => {
  const state = stateList.find(s => s.state_name === name);
  return state ? state.state_id : null;
};


const schoolTypes = [
  'Kendriya Vidyalaya',
  'Jawahar Navodaya Vidyalaya',
  'Kasturba Balika Vidyalaya',
  'Private Unaided School',
  'Private Aided School',
  'International School',
  'Special Needs School',
  'Army School',
  'Air Force School',
  'Urdu/ Madrasa School',
  'Others',
];

const pmShriOptions = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'unknown', label: "I don't know" },
];

const localityOptions = [
  { value: 'rural', label: 'Rural | ग्रामीण' },
  { value: 'semi-urban', label: 'Semi-urban | अर्ध-शहरी' },
  { value: 'urban', label: 'Urban | शहरी' },
];

// Add this style for the input group
// Redesigned teacher input group style to match premium dropdown
const teacherInputGroupStyle = {
  display: 'flex',
  alignItems: 'center',
  background: '#fcfce7', // soft yellow, matches dropdown
  border: '2px solid #b2dfdb',
  borderRadius: 10,
  boxShadow: '0 2px 8px #0001',
  padding: '0 0 0 8px',
  marginBottom: 18,
  height: 56,
  width: '50%',
  boxSizing: 'border-box',
  transition: 'border-color 0.2s, box-shadow 0.2s',
};
const teacherInputStyle = {
  flex: 1,
  border: 'none',
  background: 'transparent',
  padding: '0 16px',
  height: '100%',
  width: '100%',
  fontSize: '1.08em',
  fontWeight: 500,
  color: '#222',
  outline: 'none',
  boxSizing: 'border-box',
};
const teacherDividerStyle = {
  width: 1,
  height: 28,
  background: '#b2dfdb',
  margin: '0 8px',
};
const teacherAddBtnStyle = {
  width: 48,
  height: 48,
  border: 'none',
  background: 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  borderRadius: '0 8px 8px 0',
};

const RasActivitiesForm = () => {
  const dispatch = useDispatch();
  // Create refs for all fields that need validation scrolling
  const schoolTypeRef = React.useRef(null);
  const pmShriRef = React.useRef(null);
  const schoolEmailRef = React.useRef(null);
  const stateRef = React.useRef(null);
  const districtRef = React.useRef(null);
  const cityRef = React.useRef(null);
  const blockRef = React.useRef(null);
  const pinCodeRef = React.useRef(null);
  const localityRef = React.useRef(null);
  const principalNameRef = React.useRef(null);
  const teacherNameRef = React.useRef(null);
  const eventDateRef = React.useRef(null);
  const activity1Ref = React.useRef(null);
  const activity2Ref = React.useRef(null);
  const activity3Ref = React.useRef(null);
  const lectureConductedRef = React.useRef(null);
  const lectureExpertsRef = React.useRef(null);
  const lectureStudentsRef = React.useRef(null);
  const lectureTeachersRef = React.useRef(null);
  const lecturePhotoRef = React.useRef(null);
  const seminarConductedRef = React.useRef(null);
  const seminarExpertsRef = React.useRef(null);
  const seminarStudentsRef = React.useRef(null);
  const seminarTeachersRef = React.useRef(null);
  const seminarPhotoRef = React.useRef(null);
  const communityConductedRef = React.useRef(null);
  const communityProgramRef = React.useRef(null);
  const otherCampaignRef = React.useRef(null);
  const otherCampaignSpecifyRef = React.useRef(null);
  const seminarTopicRef = React.useRef(null);
  const siteTypeRef = React.useRef(null);
  const siteNameRef = React.useRef(null);
  const siteDistrictRef = React.useRef(null);
  const siteCityRef = React.useRef(null);
  const siteStudentsRef = React.useRef(null);
  const siteTeachersRef = React.useRef(null);
  const sitePhotoRef = React.useRef(null);
  const hasTraditionalRef = React.useRef(null);
  const traditionalNameRef = React.useRef(null);
  const traditionalTypeRef = React.useRef(null);
  const traditionalHistoryRef = React.useRef(null);
  const traditionalConditionRef = React.useRef(null);
  const restorationWorkRef = React.useRef(null);
  const rechargeConstructedRef = React.useRef(null);
  const rechargeTypeRef = React.useRef(null);
  const rechargeLocationRef = React.useRef(null);
  const rechargeShapeRef = React.useRef(null);
  const rechargeVolumeRef = React.useRef(null);
  const rechargePhotoRef = React.useRef(null);

  // Helper function to scroll to a field with smooth animation and red highlight
  const scrollToField = (ref) => {
    if (ref && ref.current) {
      const element = ref.current;

      // Store original border style
      const originalBorder = element.style.border;
      const originalBoxShadow = element.style.boxShadow;
      const originalTransition = element.style.transition;

      // Scroll to element
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      // Apply red highlight with animation
      setTimeout(() => {
        element.style.transition = 'all 0.3s ease';
        element.style.border = '3px solid #f44336';
        element.style.boxShadow = '0 0 15px rgba(244, 67, 54, 0.5)';

        // Focus the element
        element.focus();

        // Remove highlight after 3 seconds
        setTimeout(() => {
          element.style.transition = 'all 0.5s ease';
          element.style.border = originalBorder;
          element.style.boxShadow = originalBoxShadow;

          // Restore original transition after animation
          setTimeout(() => {
            element.style.transition = originalTransition;
          }, 500);
        }, 3000);
      }, 500);
    }
  };

  // Shared handler for geotagged photo upload (used for awareness and recharge)
  const handlePhotoUpload = async (e, setPhotoState, currentPhotos) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    if (files.length + (Array.isArray(currentPhotos) ? currentPhotos.length : 0) > 3) {
      toast.error('You can only upload up to 3 images.');
      e.target.value = '';
      return;
    }
    let validPhotos = Array.isArray(currentPhotos) ? [...currentPhotos] : [];
    for (const file of files) {
      try {
        const result = await processGeotaggedImage(file);
        validPhotos.push(result);
      } catch (err) {
        toast.error(err.message);
      }
    }
    if (validPhotos.length > 3) validPhotos = validPhotos.slice(0, 3);
    setPhotoState(validPhotos);
    if (validPhotos.length) toast.success('Geotagged photo(s) validated and ready!');
    e.target.value = '';
  };
  const location = useLocation();
  const navigate = useNavigate();
  const editItem = location.state && location.state.item ? location.state.item : null;
  // Recharge activity states
  // Recharge type options
  const rechargeTypeOptions = [
    { value: "pit", label: "Water Recharge Pit / जल पुनर्भरण पिट" },
    { value: "flora", label: "Native Flora-based Rainwater Harvesting / देशी वनस्पति आधारित वर्षा जल संचयन" },
    { value: "trench", label: "Water Recharge Trench / जल पुनर्भरण ट्रेंच" },
    { value: "well", label: "Water Recharge through Dry Open Well / सूखे खुले कुएं के माध्यम से जल पुनर्भरण" }
  ];
  // Card style for sections (compact)
  const cardStyle = {
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 2px 8px #0001',
    padding: '24px 18px',
    marginBottom: 18,
    width: '100%',
    boxSizing: 'border-box',
    transition: 'box-shadow 0.2s',
  };
  // Section title style (compact)
  const sectionTitleStyle = {
    color: '#357a38',
    fontWeight: 700,
    fontSize: '1.1rem',
    marginBottom: 10,
    letterSpacing: 0.5,
    textAlign: 'left',
  };
  // Responsive form container with vertical scrollbar (compact)
  const formContainerStyle = isMobile => ({
    maxWidth: 900,
    width: '100%',
    margin: '0 auto',
    padding: isMobile ? 10 : 24,
    background: '#f4f7fa',
    borderRadius: 12,
    boxShadow: '0 2px 8px #0002',
    boxSizing: 'border-box',
    maxHeight: isMobile ? 'none' : '90vh',
    overflowY: isMobile ? 'visible' : 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: '#357a38 #eaf2f8',
  });
  const [rechargeType, setRechargeType] = useState("");
  const [rechargeLocation, setRechargeLocation] = useState("");
  const [rechargeShape, setRechargeShape] = useState("");
  const [rechargeVolume, setRechargeVolume] = useState("");
  const [rechargePhoto, setRechargePhoto] = useState([]);
  // Conditional for recharge constructed
  const [rechargeConstructed, setRechargeConstructed] = useState("");
  // Get user data from Redux
  const user = useSelector(state => state.auth && state.auth.user ? state.auth.user : {});

  // Prefill logic for edit mode
  React.useEffect(() => {
    if (editItem) {
      // Prefill formState
      setFormState(prev => ({
        ...prev,
        school_email: editItem.school_email || user.schEmail || '',
        state: editItem.state || user.state || '',
        district: editItem.district || user.district || '',
        block: editItem.block || user.block || '',
        pin_code: editItem.pin_code || user.pin_code || '',
        locality: editItem.locality || user.locality || '',
        principal_name: editItem.principal_name || '',
        teacher_name: (Array.isArray(editItem.teachers) && editItem.teachers[0]?.name) ? editItem.teachers[0].name : '',
        teacher_designation: (Array.isArray(editItem.teachers) && editItem.teachers[0]?.designation) ? editItem.teachers[0].designation : '',
        seminar_topic: editItem.awareness?.seminarTopic || '',
        other_campaign_specify: editItem.awareness?.otherCampaignDetails || '',
        community_awareness_program: editItem.awareness?.communityAwarenessProgram || '',
        site_name: editItem.sitevisit?.siteName || '',
        site_state: editItem.sitevisit?.siteState || editItem.state || '',
        site_district: editItem.sitevisit?.siteDistrict || '',
        site_city: editItem.city || editItem.sitevisit?.siteCity || '',
        site_students: editItem.sitevisit?.numStudents || '',
        site_teachers: editItem.sitevisit?.numTeachers || '',
        event_date: editItem.event_date || prev.event_date,
        school_type: editItem.school_type || '',
        pm_shri: editItem.pm_shri || '',
        city: editItem.city || editItem.sitevisit?.siteCity || '',
      }));
      // Prefill teachers
      setTeachers(Array.isArray(editItem.teachers) ? editItem.teachers : []);
      // Prefill activity type and set activity selections
      const activityTypes = editItem.activity_type ? editItem.activity_type.split(',').map(t => t.trim()) : [];
      setActivity1Selected(activityTypes.includes('awareness') ? 'yes' : 'no');
      setActivity2Selected(activityTypes.includes('sitevisit') ? 'yes' : 'no');
      setActivity3Selected(activityTypes.includes('recharge') ? 'yes' : 'no');
      // Awareness
      setLectureConducted(editItem.awareness?.lectureConducted || '');
      setSeminarConducted(editItem.awareness?.seminarConducted || '');
      setCommunityConducted(editItem.awareness?.communityConducted || '');
      setOtherCampaign(editItem.awareness?.otherCampaign || '');
      setLectureExperts(editItem.awareness?.lectureConductedDetails?.experts?.toString() || '');
      setLectureStudents(editItem.awareness?.lectureConductedDetails?.students?.toString() || '');
      setLectureTeachers(editItem.awareness?.lectureConductedDetails?.teachers?.toString() || '');
      setSeminarExperts(editItem.awareness?.seminarConductedDetails?.experts?.toString() || '');
      setSeminarStudents(editItem.awareness?.seminarConductedDetails?.students?.toString() || '');
      setSeminarTeachers(editItem.awareness?.seminarConductedDetails?.teachers?.toString() || '');
      // Prefill awareness photos with existing images
      if (Array.isArray(editItem.awareness?.lecturePhoto) && editItem.awareness.lecturePhoto.length > 0) {
        setLecturePhoto(editItem.awareness.lecturePhoto.map(photo => ({
          previewUrl: photo.file,
          processedFile: null,
          latitude: photo.latitude || '',
          longitude: photo.longitude || '',
          timestamp: photo.timestamp || ''
        })));
      } else {
        setLecturePhoto([]);
      }
      if (Array.isArray(editItem.awareness?.seminarPhoto) && editItem.awareness.seminarPhoto.length > 0) {
        setSeminarPhoto(editItem.awareness.seminarPhoto.map(photo => ({
          previewUrl: photo.file,
          processedFile: null,
          latitude: photo.latitude || '',
          longitude: photo.longitude || '',
          timestamp: photo.timestamp || ''
        })));
      } else {
        setSeminarPhoto([]);
      }
      // Sitevisit
      setActivity2SiteType(editItem.sitevisit?.siteType || '');
      setActivity2SiteName(editItem.sitevisit?.siteName || '');
      setActivity2SiteDistrict(editItem.sitevisit?.siteDistrict || '');
      setActivity2SiteCity(editItem.sitevisit?.siteCity || '');
      setActivity2NumStudents(editItem.sitevisit?.numStudents?.toString() || '');
      setActivity2NumTeachers(editItem.sitevisit?.numTeachers?.toString() || '');
      // Prefill sitevisit photos as array of objects (for edit)
      if (Array.isArray(editItem.sitevisit?.photo) && editItem.sitevisit.photo.length > 0) {
        setActivity2Photo(editItem.sitevisit.photo.map(photo => ({
          previewUrl: photo.file,
          processedFile: null,
          latitude: photo.latitude || '',
          longitude: photo.longitude || '',
          timestamp: photo.timestamp || ''
        })));
      } else {
        setActivity2Photo([]);
      }
      setActivity2HasTraditional(editItem.sitevisit?.hasTraditional || '');
      setActivity2TraditionalName(editItem.sitevisit?.traditionalName || '');
      setActivity2TraditionalType(editItem.sitevisit?.traditionalType || '');
      setActivity2TraditionalTypeOther('');
      setActivity2TraditionalHistory(editItem.sitevisit?.traditionalHistory || '');
      setActivity2TraditionalCondition(editItem.sitevisit?.traditionalCondition || '');
      setActivity2RestorationWork(editItem.sitevisit?.restorationWork || '');
      // Recharge
      // Determine if recharge was constructed in edit mode - check constructed field or presence of recharge data
      setRechargeConstructed(
        editItem.recharge?.constructed ||
          (editItem.recharge?.type || editItem.recharge?.location || editItem.recharge?.shape || editItem.recharge?.volume) ? 'yes' : ''
      );
      setRechargeType(editItem.recharge?.type || '');
      setRechargeLocation(editItem.recharge?.location || '');
      setRechargeShape(editItem.recharge?.shape || '');
      setRechargeVolume(editItem.recharge?.volume?.toString() || '');
      // Prefill rechargePhoto with existing images (as preview URLs)
      if (Array.isArray(editItem.recharge?.rechargePhoto) && editItem.recharge.rechargePhoto.length > 0) {
        setRechargePhoto(editItem.recharge.rechargePhoto.map(photo => ({
          previewUrl: photo.file,
          processedFile: null,
          latitude: photo.latitude || '',
          longitude: photo.longitude || '',
          timestamp: photo.timestamp || ''
        })));
      } else {
        setRechargePhoto([]);
      }
    } else {
      // Default: prefill with user data
      setFormState((prevState) => ({
        ...prevState,
        school_type: user.school_type || prevState.school_type || '',
        school_email: user.schEmail || prevState.school_email || '',
        state: user.state || prevState.state || '',
        district: user.district || prevState.district || '',
        block: user.block || prevState.block || '',
        pin_code: user.pin_code || prevState.pin_code || '',
        locality: user.locality || prevState.locality || '',
        principal_name: user.principal_name || prevState.principal_name || '',
        teacher_name: user.teacher_name || prevState.teacher_name || '',
        teacher_designation: user.teacher_designation || prevState.teacher_designation || ''
      }));
    }
  }, [user, editItem]);
  const [selectedActivity, setSelectedActivity] = useState("");

  // Activity selection states for step-by-step flow
  const [activity1Selected, setActivity1Selected] = useState(null); // null, 'yes', or 'no'
  const [activity2Selected, setActivity2Selected] = useState(null); // null, 'yes', or 'no'
  const [activity3Selected, setActivity3Selected] = useState(null); // null, 'yes', or 'no'

  // Activity 2 states
  const [activity2SiteType, setActivity2SiteType] = useState("");
  const [activity2SiteTypeOther, setActivity2SiteTypeOther] = useState("");
  const [activity2SiteName, setActivity2SiteName] = useState("");
  const [activity2SiteDistrict, setActivity2SiteDistrict] = useState("");
  const [activity2SiteCity, setActivity2SiteCity] = useState("");
  const [activity2NumStudents, setActivity2NumStudents] = useState("");
  const [activity2NumTeachers, setActivity2NumTeachers] = useState("");
  const [activity2Photo, setActivity2Photo] = useState(null);
  // Section 2
  const [activity2HasTraditional, setActivity2HasTraditional] = useState("");
  const [activity2TraditionalName, setActivity2TraditionalName] = useState("");
  const [activity2TraditionalType, setActivity2TraditionalType] = useState("");
  const [activity2TraditionalTypeOther, setActivity2TraditionalTypeOther] = useState("");
  const [activity2TraditionalHistory, setActivity2TraditionalHistory] = useState("");
  const [activity2TraditionalCondition, setActivity2TraditionalCondition] = useState("");
  const [activity2RestorationWork, setActivity2RestorationWork] = useState("");
  // Activity 2 states
  // Awareness campaign sub-question states
  const [lectureConducted, setLectureConducted] = useState("");
  const [seminarConducted, setSeminarConducted] = useState("");
  const [communityConducted, setCommunityConducted] = useState("");
  const [otherCampaign, setOtherCampaign] = useState("");
  const [lecturePhoto, setLecturePhoto] = useState(null);
  const [seminarPhoto, setSeminarPhoto] = useState(null);
  const [seminarExperts, setSeminarExperts] = useState("");
  const [seminarStudents, setSeminarStudents] = useState("");
  const [seminarTeachers, setSeminarTeachers] = useState("");
  // Community campaign participant counts
  // Controlled states for lecture conducted details
  const [lectureExperts, setLectureExperts] = useState("");
  const [lectureStudents, setLectureStudents] = useState("");
  const [lectureTeachers, setLectureTeachers] = useState("");

  // Handler for geotagged photo upload

  // Prefill from backend or localStorage if available
  React.useEffect(() => {
    // Only prefill if not editing an existing item
    if (editItem) return;

    const fetchLatestAndPrefill = async () => {
      try {
        let prefetchedData = null;

        // 1. Try fetching from backend first
        if (user.udise_id) {
          try {
            const response = await axiosConn("post", "get-latest-ras-activity", { udise_id: user.udise_id }, {}, dispatch);
            if (response.data.status === "success" && response.data.data) {
              prefetchedData = response.data.data;
              console.log("Fetched latest RAS activity for prefill:", prefetchedData);
            }
          } catch (err) {
            console.error("Error fetching latest RAS activity:", err);
          }
        }

        // 2. If no backend data, try localStorage
        if (!prefetchedData) {
          const saved = localStorage.getItem('rasActivityPrefill');
          if (saved) {
            try {
              prefetchedData = JSON.parse(saved);
              console.log('📦 Loading from localStorage:', prefetchedData);
            } catch (err) {
              console.error('Error parsing localStorage:', err);
            }
          }
        }

        // 3. Apply prefill data if found
        if (prefetchedData) {
          setFormState(prev => ({
            ...prev,
            school_type: prefetchedData.school_type || user.school_type || prev.school_type || '',
            pm_shri: prefetchedData.pm_shri || prev.pm_shri || '',
            school_email: prefetchedData.school_email || user.schEmail || prev.school_email || '',
            state: prefetchedData.state || user.state || prev.state || '',
            district: prefetchedData.district || user.district || prev.district || '',
            city: prefetchedData.city || prev.city || '',
            block: prefetchedData.block || user.block || prev.block || '',
            pin_code: prefetchedData.pin_code || user.pin_code || prev.pin_code || '',
            locality: prefetchedData.locality || user.locality || prev.locality || '',
            principal_name: prefetchedData.principal_name || user.hosName || prev.principal_name || '',
          }));

          // Handle teachers array
          if (Array.isArray(prefetchedData.teachers) && prefetchedData.teachers.length > 0) {
            console.log('👥 Setting teachers from prefill:', prefetchedData.teachers);
            setTeachers(prefetchedData.teachers);
            setShowTeachers(true);
          } else if (prefetchedData.teacher_name) {
            // Fallback for older data format
            setTeachers([{
              name: prefetchedData.teacher_name,
              designation: prefetchedData.teacher_designation || ''
            }]);
            setShowTeachers(true);
          }
        } else {
          // 4. Final fallback to user profile data
          setFormState((prevState) => ({
            ...prevState,
            school_type: user.school_type || prevState.school_type || '',
            school_email: user.schEmail || prevState.school_email || '',
            state: user.state || prevState.state || '',
            district: user.district || prevState.district || '',
            block: user.block || prevState.block || '',
            pin_code: user.pin_code || prevState.pin_code || '',
            locality: user.locality || prevState.locality || '',
            principal_name: user.hosName || user['hosName '] || user.principal_name || '',
            teacher_name: user.teacher_name || prevState.teacher_name || '',
            teacher_designation: user.teacher_designation || prevState.teacher_designation || ''
          }));
        }
      } catch (err) {
        console.error('Error during prefill process:', err);
      }
    };

    fetchLatestAndPrefill();
  }, [user, editItem, dispatch]);

  // Fetch principal name from school_lists DB using hosName field
  React.useEffect(() => {
    const fetchPrincipalName = async () => {
      if (!editItem) {
        // First try to get from user object (Redux state)
        const userPrincipalName = user.hosName || user['hosName '] || user.principal_name || '';

        if (userPrincipalName) {
          console.log('✅ Setting principal_name from user object:', userPrincipalName);
          setFormState(prev => ({
            ...prev,
            principal_name: userPrincipalName
          }));
          return;
        }

        // If not in user object, fetch from API
        if (user.udise_id) {
          try {
            console.log('🔍 Fetching principal name for UDISE:', user.udise_id);
            const response = await axios.post(`${baseURL}/get-school-filter`, {
              udise_id: user.udise_id
            });
            console.log('📦 Full API Response:', response.data);

            if (response.data && response.data.status === 'success' && response.data.result && response.data.result.length > 0) {
              const schoolData = response.data.result[0];
              console.log('🏫 School Data found:', schoolData);

              // Try both 'hosName' and 'hosName ' (with space) due to DB field naming
              const principalName = schoolData.hosName || schoolData['hosName '] || '';

              if (principalName) {
                console.log('✅ Setting principal_name from API:', principalName);
                setFormState(prev => ({
                  ...prev,
                  principal_name: principalName
                }));
              } else {
                console.log('⚠️ hosName field not found in school data');
              }
            } else {
              console.log('⚠️ No school data found for UDISE:', user.udise_id);
            }
          } catch (error) {
            console.error('❌ Error fetching principal name:', error);
            console.error('Error details:', error.response?.data || error.message);
          }
        }
      }
    };
    fetchPrincipalName();
  }, [user.udise_id, user.hosName, user['hosName '], editItem]);

  // Form state for all fields (add as needed)
  const [formState, setFormState] = useState({
    recharge_volume: '',
    recharge_photo: null,
    recharge_location: '',
    traditional_site_name: '',
    traditional_structure_type: '',
    traditional_historical_background: '',
    traditional_present_condition: '',
    school_type: user.school_type || '',
    pm_shri: '',
    school_email: user.schEmail || '',
    state: user.state || '',
    district: user.district || '',
    city: '',
    block: user.block || '',
    pin_code: user.pin_code || '',
    locality: user.locality || '',
    principal_name: user.hosName || user['hosName '] || user.principal_name || '',
    teacher_name: user.teacher_name || '',
    teacher_designation: user.teacher_designation || '',
    seminar_topic: '',
    other_campaign_specify: '',
    community_awareness_program: '',
    site_name: '',
    site_district: '',
    site_city: '',
    site_students: '',
    site_teachers: '',
    event_date: (() => {
      // Use local time (IST for Indian users)
      const now = new Date();
      const pad = n => n < 10 ? '0' + n : n;
      const yyyy = now.getFullYear();
      const mm = pad(now.getMonth() + 1);
      const dd = pad(now.getDate());
      const hh = pad(now.getHours());
      const min = pad(now.getMinutes());
      return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
    })()
  });

  // Multi-teacher state (name + designation)
  const [teacherNameInput, setTeacherNameInput] = useState("");
  const [teacherDesignationInput, setTeacherDesignationInput] = useState("");
  const [teachers, setTeachers] = useState([]); // [{ name, designation }]
  const [showTeachers, setShowTeachers] = useState(false);
  const [isAddingTeacher, setIsAddingTeacher] = useState(false);

  // Handle input changes for all fields
  const alphaOnlyFields = [
    'recharge_location',
    'traditional_site_name',
    'city',
    'principal_name',
    'teacher_name',
    'teacher_designation',
    'seminar_topic',
    'other_campaign_specify',
    'community_awareness_program',
    'site_name',
    'site_district',
    'site_city',
  ];
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (["recharge_volume"].includes(name)) {
      if (!/^[0-9]*$/.test(value)) return;
    }
    if (["traditional_structure_type", "traditional_present_condition"].includes(name)) {
      setFormState((prev) => ({ ...prev, [name]: value }));
      return;
    }
    if (alphaOnlyFields.includes(name)) {
      if (!/^[A-Za-z ]*$/.test(value)) return;
    }
    if (["site_students", "site_teachers"].includes(name)) {
      if (!/^[0-9]*$/.test(value)) return;
    }
    // For multi-teacher input, don't update formState.teacher_name or teacher_designation directly
    if (name === "teacher_name") {
      setTeacherNameInput(value);
      return;
    }
    if (name === "teacher_designation") {
      setTeacherDesignationInput(value);
      return;
    }
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Extra validation for readOnly/user fields
    if (!user.school_name && !user.name) {
      toast.dismiss();
      toast.warning('School Name is required');
      return;
    }
    if (!user.udise_id) {
      toast.dismiss();
      toast.warning('UDISE Code is required');
      return;
    }
    // Validation checks with toast notifications
    const warnings = [
      { condition: !formState.school_type, message: "Please select School Type", ref: schoolTypeRef },
      { condition: !formState.pm_shri, message: "Please select PM SHRI status", ref: pmShriRef },
      { condition: !formState.school_email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formState.school_email), message: "Please enter a valid School Email", ref: schoolEmailRef },
      { condition: !formState.state || formState.state === "Select State", message: "Please select State", ref: stateRef },
      { condition: !formState.district || formState.district === "Select District", message: "Please select District", ref: districtRef },
      { condition: !formState.city || !/^[A-Za-z ]+$/.test(formState.city), message: "Please enter a valid City (alphabets only)", ref: cityRef },
      { condition: !formState.block, message: "Please enter Block", ref: blockRef },
      { condition: !formState.pin_code || formState.pin_code < 100000 || formState.pin_code > 999999, message: "Please enter a valid 6-digit PIN code", ref: pinCodeRef },
      { condition: !formState.locality, message: "Please select Locality", ref: localityRef },
      { condition: !formState.principal_name || !/^[A-Za-z ]+$/.test(formState.principal_name), message: "Please enter Principal/Head name (alphabets only)", ref: principalNameRef },
      { condition: teachers.length === 0 && (!formState.teacher_name || !formState.teacher_designation), message: "Please add at least one teacher or fill teacher details", ref: teacherNameRef },
      { condition: !formState.udise_code && !user.udise_id, message: "Please enter UDISE Code", ref: null },
      { condition: !formState.event_date, message: "Please select Event Date", ref: eventDateRef },
      { condition: activity1Selected === null, message: "Please answer Activity 1: Yes or No", ref: activity1Ref },
      { condition: activity2Selected === null, message: "Please answer Activity 2: Yes or No", ref: activity2Ref },
      { condition: activity3Selected === null, message: "Please answer Activity 3: Yes or No", ref: activity3Ref },
      { condition: activity1Selected !== 'yes' && activity2Selected !== 'yes' && activity3Selected !== 'yes', message: "Please select at least one Activity as Yes", ref: activity1Ref },
    ];

    // Activity-specific validations
    if (activity1Selected === 'yes') {
      warnings.push(
        { condition: !lectureConducted, message: "Please select if Lecture was conducted", ref: lectureConductedRef },
        { condition: lectureConducted === "yes" && !lectureExperts?.toString().trim(), message: "Please enter number of experts participated in lecture", ref: lectureExpertsRef },
        { condition: lectureConducted === "yes" && !lectureStudents?.toString().trim(), message: "Please enter number of students participated in lecture", ref: lectureStudentsRef },
        { condition: lectureConducted === "yes" && !lectureTeachers?.toString().trim(), message: "Please enter number of teachers participated in lecture", ref: lectureTeachersRef },
        { condition: lectureConducted === "yes" && (!lecturePhoto || lecturePhoto.length === 0), message: "Please upload at least one Lecture photo", ref: lecturePhotoRef },
        { condition: !seminarConducted, message: "Please select if Seminar was conducted", ref: seminarConductedRef },
        { condition: seminarConducted === "yes" && !formState.seminar_topic?.toString().trim(), message: "Please enter Seminar Topic", ref: seminarTopicRef },
        { condition: seminarConducted === "yes" && !seminarExperts?.toString().trim(), message: "Please enter number of experts participated in seminar", ref: seminarExpertsRef },
        { condition: seminarConducted === "yes" && !seminarStudents?.toString().trim(), message: "Please enter number of students participated in seminar", ref: seminarStudentsRef },
        { condition: seminarConducted === "yes" && !seminarTeachers?.toString().trim(), message: "Please enter number of teachers participated in seminar", ref: seminarTeachersRef },
        { condition: seminarConducted === "yes" && (!seminarPhoto || seminarPhoto.length === 0), message: "Please upload at least one Seminar photo", ref: seminarPhotoRef },
        { condition: !communityConducted, message: "Please select if Community Campaign was conducted", ref: communityConductedRef },
        { condition: communityConducted === "yes" && !formState.community_awareness_program?.toString().trim(), message: "Please specify about the community awareness program", ref: communityProgramRef },
        { condition: !otherCampaign, message: "Please select if Other Campaign was conducted", ref: otherCampaignRef },
        { condition: otherCampaign === "yes" && !formState.other_campaign_specify?.toString().trim(), message: "Please specify Other Campaign details", ref: otherCampaignSpecifyRef }
      );
    }

    if (activity2Selected === 'yes') {
      warnings.push(
        { condition: !activity2SiteType?.toString().trim() && !activity2SiteTypeOther?.toString().trim(), message: "Please select Site Type", ref: siteTypeRef },
        { condition: !activity2SiteName?.toString().trim(), message: "Please enter Site Name", ref: siteNameRef },
        { condition: !activity2SiteDistrict?.toString().trim(), message: "Please enter Site District", ref: siteDistrictRef },
        { condition: !activity2SiteCity?.toString().trim(), message: "Please enter Site City", ref: siteCityRef },
        { condition: !activity2NumStudents?.toString().trim() || activity2NumStudents < 0, message: "Please enter valid number of Students", ref: siteStudentsRef },
        { condition: !activity2NumTeachers?.toString().trim() || activity2NumTeachers < 0, message: "Please enter valid number of Teachers", ref: siteTeachersRef },
        { condition: !activity2Photo || activity2Photo.length === 0, message: "Please upload at least one Site Visit photo", ref: sitePhotoRef },
        { condition: !activity2HasTraditional, message: "Please select if site has Traditional water body", ref: hasTraditionalRef },
        { condition: activity2HasTraditional === "yes" && !activity2TraditionalName?.toString().trim(), message: "Please enter Traditional water body name", ref: traditionalNameRef },
        { condition: activity2HasTraditional === "yes" && !activity2TraditionalType?.toString().trim() && !activity2TraditionalTypeOther?.toString().trim(), message: "Please select Traditional water body type", ref: traditionalTypeRef },
        { condition: activity2HasTraditional === "yes" && !activity2TraditionalHistory?.toString().trim(), message: "Please enter Historical significance", ref: traditionalHistoryRef },
        { condition: activity2HasTraditional === "yes" && !activity2TraditionalCondition?.toString().trim(), message: "Please select Current condition", ref: traditionalConditionRef },
        { condition: activity2HasTraditional === "yes" && !activity2RestorationWork?.toString().trim(), message: "Please select Restoration work status", ref: restorationWorkRef }
      );
    }

    if (activity3Selected === 'yes') {
      // Validate recharge constructed question first
      warnings.push(
        { condition: !rechargeConstructed, message: "Please select if Ground Water Recharge System was constructed", ref: rechargeConstructedRef }
      );
      // Only validate recharge details if constructed is 'yes'
      if (rechargeConstructed === "yes") {
        warnings.push(
          { condition: !rechargeType?.toString().trim(), message: "Please select Recharge System Type", ref: rechargeTypeRef },
          { condition: !rechargeLocation?.toString().trim(), message: "Please enter Recharge Location", ref: rechargeLocationRef },
          { condition: !rechargeShape?.toString().trim(), message: "Please select Pit Shape", ref: rechargeShapeRef },
          { condition: !rechargeVolume?.toString().trim() || rechargeVolume <= 0, message: "Please enter valid Pit Volume", ref: rechargeVolumeRef },
          { condition: !rechargePhoto || rechargePhoto.length === 0, message: "Please upload at least one Recharge System photo", ref: rechargePhotoRef }
        );
      }
    }

    // Check all warnings
    for (const { condition, message, ref } of warnings) {
      toast.dismiss();
      if (condition) {
        toast.warning(message);
        // Scroll to the field that has error
        if (ref) {
          scrollToField(ref);
        }
        return;
      }
    }

    // Save first 14 fields and teachers array to localStorage for prefill
    const prefillFields = [
      'school_type', 'pm_shri', 'school_email', 'state', 'district', 'city',
      'block', 'pin_code', 'locality', 'principal_name', 'teacher_name',
      'teacher_designation', 'event_date', 'udise_code'
    ];
    const prefillData = {};
    prefillFields.forEach(f => {
      if (formState[f] !== undefined) prefillData[f] = formState[f];
    });
    // Also add UDISE from user if not in formState
    if (!prefillData.udise_code && user.udise_id) prefillData.udise_code = user.udise_id;
    // Add teachers array
    prefillData.teachers = teachers;
    localStorage.setItem('rasActivityPrefill', JSON.stringify(prefillData));
    try {
      const formData = new FormData();
      // School details
      formData.append('school_name', user.school_name || user.name || '');
      formData.append('udise_id', user.udise_id || '');
      Object.entries(formState).forEach(([key, value]) => {
        // Skip teacher_name, teacher_designation, and teachers - these are handled separately
        if (key === 'teacher_name' || key === 'teacher_designation' || key === 'teachers') return;
        formData.append(key, value);
      });
      // Add teachers as JSON string - ensure teachers array is properly stringified
      console.log('👥 Teachers state before submit:', teachers);
      const teachersToSend = Array.isArray(teachers) && teachers.length > 0
        ? teachers.map(t => ({
          name: t.name || '',
          designation: t.designation || ''
        }))
        : [];
      console.log('📤 Sending teachers to backend:', teachersToSend);
      formData.append('teachers', JSON.stringify(teachersToSend));

      // Send all selected activities
      const selectedActivities = [];
      if (activity1Selected === 'yes') selectedActivities.push('awareness');
      if (activity2Selected === 'yes') selectedActivities.push('sitevisit');
      if (activity3Selected === 'yes') selectedActivities.push('recharge');
      formData.append('activity_type', selectedActivities.join(','));

      if (activity1Selected === 'yes') {
        // Awareness campaign
        formData.append('awareness[lectureConducted]', lectureConducted);
        if (lectureConducted === "yes") {
          formData.append('awareness[lectureConductedExperts]', lectureExperts);
          formData.append('awareness[lectureConductedStudents]', lectureStudents);
          formData.append('awareness[lectureConductedTeachers]', lectureTeachers);
        }
        formData.append('awareness[seminarConducted]', seminarConducted);
        if (seminarConducted === "yes") {
          formData.append('awareness[seminarConductedExperts]', seminarExperts);
          formData.append('awareness[seminarConductedStudents]', seminarStudents);
          formData.append('awareness[seminarConductedTeachers]', seminarTeachers);
        }
        formData.append('awareness[communityConducted]', communityConducted);
        // No participant counts for community campaign, so skip these fields
        // If needed, add fields and states for experts, students, teachers
        formData.append('awareness[otherCampaign]', otherCampaign);
        if (otherCampaign === "yes") {
          formData.append('awareness[other_campaign_specify]', formState.other_campaign_specify);
        }
        // Append all lecture photos
        if (Array.isArray(lecturePhoto)) {
          lecturePhoto.forEach(photoObj => {
            if (photoObj.processedFile) {
              formData.append('lecturePhoto', photoObj.processedFile);
              formData.append('awareness[lecturePhoto][latitude]', photoObj.latitude);
              formData.append('awareness[lecturePhoto][longitude]', photoObj.longitude);
              formData.append('awareness[lecturePhoto][timestamp]', photoObj.timestamp);
            } else if (photoObj.previewUrl) {
              formData.append('lecturePhotoExisting', JSON.stringify({
                file: photoObj.previewUrl,
                latitude: photoObj.latitude,
                longitude: photoObj.longitude,
                timestamp: photoObj.timestamp
              }));
            }
          });
        }
        // Append all seminar photos
        if (Array.isArray(seminarPhoto)) {
          seminarPhoto.forEach(photoObj => {
            if (photoObj.processedFile) {
              formData.append('seminarPhoto', photoObj.processedFile);
              formData.append('awareness[seminarPhoto][latitude]', photoObj.latitude);
              formData.append('awareness[seminarPhoto][longitude]', photoObj.longitude);
              formData.append('awareness[seminarPhoto][timestamp]', photoObj.timestamp);
            } else if (photoObj.previewUrl) {
              formData.append('seminarPhotoExisting', JSON.stringify({
                file: photoObj.previewUrl,
                latitude: photoObj.latitude,
                longitude: photoObj.longitude,
                timestamp: photoObj.timestamp
              }));
            }
          });
        }
      }

      if (activity2Selected === 'yes') {
        // Activity 2: Water Conservation site(s) visited by the students
        formData.append('sitevisit[siteType]', activity2SiteType === "other" ? activity2SiteTypeOther : activity2SiteType);
        formData.append('sitevisit[siteName]', activity2SiteName);
        formData.append('sitevisit[siteState]', formState.site_state || '');
        formData.append('sitevisit[siteDistrict]', activity2SiteDistrict);
        formData.append('sitevisit[siteCity]', activity2SiteCity);
        formData.append('sitevisit[numStudents]', activity2NumStudents);
        formData.append('sitevisit[numTeachers]', activity2NumTeachers);
        if (Array.isArray(activity2Photo)) {
          activity2Photo.forEach(photoObj => {
            if (photoObj.processedFile) {
              // New upload
              formData.append('sitePhoto', photoObj.processedFile);
              formData.append('sitevisit[photo][latitude]', photoObj.latitude);
              formData.append('sitevisit[photo][longitude]', photoObj.longitude);
              formData.append('sitevisit[photo][timestamp]', photoObj.timestamp);
            } else if (photoObj.previewUrl) {
              // Existing image, send as JSON string
              formData.append('sitePhotoExisting', JSON.stringify({
                file: photoObj.previewUrl,
                latitude: photoObj.latitude,
                longitude: photoObj.longitude,
                timestamp: photoObj.timestamp
              }));
            }
          });
        }
        formData.append('sitevisit[hasTraditional]', activity2HasTraditional);
        if (activity2HasTraditional === "yes") {
          formData.append('sitevisit[traditionalName]', activity2TraditionalName);
          formData.append('sitevisit[traditionalType]', activity2TraditionalType === "other" ? activity2TraditionalTypeOther : activity2TraditionalType);
          formData.append('sitevisit[traditionalHistory]', activity2TraditionalHistory);
          formData.append('sitevisit[traditionalCondition]', activity2TraditionalCondition);
          formData.append('sitevisit[restorationWork]', activity2RestorationWork);
        }
      }

      if (activity3Selected === 'yes') {
        // Activity 3: Ground Water Recharge System/Pit
        formData.append('rechargeConstructed', rechargeConstructed);
        // Only append recharge details if constructed is 'yes'
        if (rechargeConstructed === "yes") {
          formData.append('recharge[type]', rechargeType);
          formData.append('recharge[location]', rechargeLocation);
          formData.append('recharge[shape]', rechargeShape);
          formData.append('recharge[volume]', rechargeVolume);
          // Append all recharge photos and their geotag data (indexed)
          if (Array.isArray(rechargePhoto)) {
            rechargePhoto.forEach((photoObj, idx) => {
              if (photoObj.processedFile) {
                // New upload
                formData.append('rechargePhoto', photoObj.processedFile);
                formData.append(`recharge[photo][${idx}][latitude]`, photoObj.latitude);
                formData.append(`recharge[photo][${idx}][longitude]`, photoObj.longitude);
                formData.append(`recharge[photo][${idx}][timestamp]`, photoObj.timestamp);
              } else if (photoObj.previewUrl) {
                // Existing image, send as JSON string
                formData.append('rechargePhotoExisting', JSON.stringify({
                  file: photoObj.previewUrl,
                  latitude: photoObj.latitude,
                  longitude: photoObj.longitude,
                  timestamp: photoObj.timestamp
                }));
              }
            });
          }
        }
      }

      // Submit to backend (update if editing, else create new)
      let response;
      if (editItem && editItem._id) {
        response = await axiosConn(
          'post',
          `update-ras-activity/${editItem._id}`,
          formData,
          { 'Content-Type': 'multipart/form-data' },
          dispatch
        );
        if (response.data.success) {
          toast.success('RAS activity updated successfully!');
          navigate('/school/ras-activities-list');
        } else {
          toast.error('Update failed.');
        }
      } else {
        response = await axiosConn(
          'post',
          'ras-activities',
          formData,
          { 'Content-Type': 'multipart/form-data' },
          dispatch
        );
        if (response.data.success) {
          toast.success('RAS activity submitted successfully!');
          navigate('/school/ras-activities-list');
        } else {
          toast.error('Submission failed.');
        }
      }
    } catch (err) {
      toast.error('Submission failed: ' + (err.response?.data?.message || err.message));
    }
  };

  // Check if screen is mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Update isMobile state on window resize
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Add global style for custom scrollbar (Webkit)
  React.useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .ras-activities-scrollable::-webkit-scrollbar {
        width: 10px;
      }
      .ras-activities-scrollable::-webkit-scrollbar-thumb {
        background: #b2dfdb;
        border-radius: 8px;
      }
      .ras-activities-scrollable::-webkit-scrollbar-track {
        background: #f4f7fa;
        border-radius: 8px;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f5f5f5', flexDirection: isMobile ? 'column' : 'row' }}>
      {isMobile ? null : <SideBar index={10} />}
      <div style={{ flex: 1, padding: isMobile ? '16px' : '40px' }}>
        <div
          className={isMobile ? '' : 'ras-activities-scrollable'}
          style={{
            maxWidth: '1400px',
            margin: '0 auto',
            background: '#fff',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            padding: isMobile ? '56px 20px 20px 20px' : '90px 40px 40px 40px', // Increased extra top padding
            maxHeight: isMobile ? 'none' : '90vh',
            overflowY: isMobile ? 'visible' : 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#357a38 #eaf2f8',
          }}
        >
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '2px solid #e0e0e0',
            paddingBottom: '15px',
            marginBottom: '30px',
          }}>
            <h2 style={{
              color: '#2e7d32',
              fontSize: isMobile ? '1.5rem' : '2rem',
              fontWeight: 600,
              margin: 0,
            }}>RAS 2025-26 Activities</h2>
            <p style={{
              color: '#666',
              fontSize: isMobile ? '0.9rem' : '1rem',
              margin: 0,
            }}></p>
          </div>

          {/* Validity notice */}
          <div style={{
            background: '#fff3cd',
            border: '1px solid #ffe69c',
            borderRadius: '8px',
            padding: '10px 14px',
            marginBottom: '24px',
            color: '#8a6d3b',
            fontSize: isMobile ? '0.85rem' : '0.95rem',
            fontWeight: 600,
            textAlign: 'center',
          }}>
            ⚠️ Note: RAS 2025-26 activities can be submitted only up to 30th June 2026. | ध्यान दें: आर.ए.एस. 2025-26 गतिविधियाँ केवल 30 जून 2026 तक जमा की जा सकती हैं।
          </div>

          <form className='' onSubmit={handleSubmit} encType="multipart/form-data" noValidate>
            {/* Section Header */}
            <div style={{ marginBottom: '12px' }}>
              <h3 style={{ color: '#2e7d32', fontSize: isMobile ? '1.08rem' : '1.18rem', fontWeight: 600, margin: 0 }}>School Details | विद्यालय विवरण</h3>
            </div>

            {/* Row 1: Name, UDISE, Date */}
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: '12px', marginBottom: '12px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>1. Name of School | विद्यालय का नाम <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                <input
                  type="text"
                  className="form-control"
                  style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                  placeholder="Enter school name"
                  required
                  value={user.school_name || user.name || ''}
                  readOnly
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>2. UDISE Code | यूडाइस कोड <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                <input
                  type="text"
                  className="form-control"
                  style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                  placeholder="Enter UDISE code"
                  required
                  value={user.udise_id || ''}
                  readOnly
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>3. Date of Event | कार्यक्रम की तिथि <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                <input
                  ref={eventDateRef}
                  type="datetime-local"
                  name="event_date"
                  required
                  className='form-control'
                  style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                  value={formState.event_date || ''}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            {/* Row 2: School Type, PM Shri, Email */}
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: '12px', marginBottom: '12px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>4. Select the type of your school | अपने विद्यालय का प्रकार चुनें <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                <select
                  ref={schoolTypeRef}
                  name="school_type"
                  className="form-control"
                  style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                  required
                  value={formState.school_type || ''}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>Select school type</option>
                  {schoolTypes.map(t => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>5. Is your school a PM Shri School? | क्या आपका विद्यालय पी.एम. श्री स्कूल है? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                <select ref={pmShriRef} name="pm_shri" required className='form-control' style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} value={formState.pm_shri} onChange={handleInputChange}>
                  <option value="" disabled>Select</option>
                  {pmShriOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>6. School E-mail | विद्यालय का ई-मेल <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                <input
                  ref={schoolEmailRef}
                  type="email"
                  name="school_email"
                  className="form-control"
                  style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                  placeholder="Enter school email"
                  required
                  value={formState.school_email}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            {/* Row 3: State, District, City */}
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: '12px', marginBottom: '12px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>7. State/Union Territory | राज्य/केंद्र शासित प्रदेश <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                <select
                  ref={stateRef}
                  name="state"
                  type="text"
                  required
                  className='form-control'
                  style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                  value={formState.state}
                  onChange={e => {
                    const selectedState = e.target.value;
                    setFormState(prev => ({ ...prev, state: selectedState, district: '' }));
                  }}
                >
                  <option value="" disabled>Select state/UT</option>
                  {stateList.map(state => (
                    <option key={state.state_id} value={state.state_name}>{state.state_name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>8. District Name | जिला का नाम <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                <select
                  ref={districtRef}
                  name="district"
                  className="form-control"
                  style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                  required
                  value={formState.district}
                  onChange={e => setFormState(prev => ({ ...prev, district: e.target.value }))}
                  disabled={!formState.state}
                >
                  <option value="" disabled>{formState.state ? 'Select district' : 'Select state first'}</option>
                  {formState.state && getDistrictsByStateId(getStateIdByName(formState.state)).map(district => (
                    <option key={district.district_id} value={district.district_name}>{district.district_name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>9. City | शहर <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                <input ref={cityRef} type="text" name="city" className="form-control" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} placeholder="Enter city" required value={formState.city} onChange={handleInputChange} pattern="^[A-Za-z ]+$" title="Only alphabets allowed" maxLength="400" onInput={e => { if (e.target.value.length > 400) e.target.value = e.target.value.slice(0, 400); }} />
              </div>
            </div>

            {/* Row 4: Block, PIN, Locality */}
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: '12px', marginBottom: '12px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>10. Block/Town/Sector where the school is located | ब्लॉक/शहर/सेक्टर, जहाँ स्कूल स्थित है <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                <input
                  ref={blockRef}
                  type="text"
                  name="block"
                  className="form-control"
                  style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                  placeholder="Enter block/town/sector"
                  required
                  value={formState.block}
                  onChange={handleInputChange}
                  maxLength="400"
                  onInput={e => { if (e.target.value.length > 400) e.target.value = e.target.value.slice(0, 400); }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>11. PIN Code | पिन कोड <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                <input ref={pinCodeRef} type="number" name="pin_code" className="form-control" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} placeholder="Enter PIN code" required value={formState.pin_code} onChange={handleInputChange} min="100000" max="999999" title="Only numbers allowed" />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>12. Locality of School | विद्यालय का स्थान (Urban/Semi-urban/Rural) <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                <select ref={localityRef} name="locality" required className="form-control" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} value={formState.locality} onChange={handleInputChange} onFocus={e => e.target.style.borderColor = '#28a745'} onBlur={e => e.target.style.borderColor = '#CAE769'}>
                  <option value="" disabled>Select locality</option>
                  {localityOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Row 5: Principal Name - Full Width */}
            <div style={{ marginBottom: '12px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>13. Name of Principal / Head of School | विद्यालय के प्रधानाध्यापक/संचालक का नाम <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                <input ref={principalNameRef} type="text" name="principal_name" className="form-control" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} placeholder="Enter principal/head name" required value={formState.principal_name} onChange={handleInputChange} pattern="^[A-Za-z ]+$" title="Only alphabets allowed" maxLength="400" onInput={e => { if (e.target.value.length > 400) e.target.value = e.target.value.slice(0, 400); }} />
              </div>
            </div>

            {/* Row 6: Teacher Name & Designation */}
            <div style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>14. Name & Designation of Teacher(s) involved in guiding the activities<br />
                क्रियाकलापों के समय मार्गदर्शन करने वाले अध्यापक/अध्यापकों का नाम व पद <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span>
              </label>

              {/* Input fields for teacher */}
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                <input
                  ref={teacherNameRef}
                  name="teacher_name"
                  className="form-control"
                  placeholder="Enter teacher name"
                  required={teachers.length === 0}
                  value={teacherNameInput}
                  onChange={handleInputChange}
                  pattern="^[A-Za-z ]+$"
                  title="Only alphabets allowed"
                  disabled={teachers.length > 0 && !isAddingTeacher}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '2px solid #CAE769',
                    borderRadius: '4px',
                    fontSize: '14px',
                    backgroundColor: (teachers.length > 0 && !isAddingTeacher) ? '#f5f5f5' : '#fff',
                    cursor: (teachers.length > 0 && !isAddingTeacher) ? 'not-allowed' : 'text'
                  }}
                />
                <input
                  type="text"
                  name="teacher_designation"
                  className="form-control"
                  placeholder="Enter designation"
                  required={teachers.length === 0}
                  value={teacherDesignationInput}
                  onChange={handleInputChange}
                  pattern="^[A-Za-z ]+$"
                  title="Only alphabets allowed"
                  disabled={teachers.length > 0 && !isAddingTeacher}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '2px solid #CAE769',
                    borderRadius: '4px',
                    fontSize: '14px',
                    backgroundColor: (teachers.length > 0 && !isAddingTeacher) ? '#f5f5f5' : '#fff',
                    cursor: (teachers.length > 0 && !isAddingTeacher) ? 'not-allowed' : 'text'
                  }}
                />
              </div>

              {/* Add Teacher Button - Show when no teachers added OR when adding more */}
              {(teachers.length === 0 || isAddingTeacher) && (
                <button
                  type="button"
                  onClick={() => {
                    if (
                      teacherNameInput.trim() &&
                      teacherDesignationInput.trim() &&
                      /^[A-Za-z ]+$/.test(teacherNameInput) &&
                      /^[A-Za-z ]+$/.test(teacherDesignationInput)
                    ) {
                      setTeachers(prev => [...prev, { name: teacherNameInput.trim(), designation: teacherDesignationInput.trim() }]);
                      setTeacherNameInput("");
                      setTeacherDesignationInput("");
                      setIsAddingTeacher(false);
                    } else {
                      toast.warning('Please enter valid teacher name and designation (alphabets only)');
                    }
                  }}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#2e7d32',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s',
                    width: isMobile ? '100%' : 'auto'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#1b5e20'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#2e7d32'}
                >
                  Add Teacher
                </button>
              )}

              {/* Display added teachers */}
              {teachers.length > 0 && !isAddingTeacher && (
                <div style={{
                  marginTop: '12px',
                  padding: '12px',
                  backgroundColor: '#f1f8e9',
                  borderRadius: '8px',
                  border: '1px solid #c5e1a5'
                }}>
                  <div style={{ fontWeight: '600', color: '#2e7d32', marginBottom: '10px', fontSize: '14px' }}>
                    Added Teachers:
                  </div>
                  {teachers.map((t, idx) => (
                    <div key={idx} style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '8px 12px',
                      marginBottom: '8px',
                      backgroundColor: '#fff',
                      borderRadius: '6px',
                      border: '1px solid #dcedc8'
                    }}>
                      <span style={{ fontSize: '14px' }}>
                        <b>{t.name}</b> <span style={{ color: '#666' }}>({t.designation})</span>
                      </span>
                      <button
                        type="button"
                        style={{
                          color: '#d32f2f',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          fontWeight: '600',
                          fontSize: '13px',
                          padding: '4px 8px'
                        }}
                        onClick={() => setTeachers(prev => prev.filter((_, i) => i !== idx))}
                      >
                        Remove
                      </button>
                    </div>
                  ))}

                  {/* Add More Teachers Button */}
                  <button
                    type="button"
                    onClick={() => {
                      setIsAddingTeacher(true);
                      setTeacherNameInput("");
                      setTeacherDesignationInput("");
                    }}
                    style={{
                      marginTop: '8px',
                      padding: '8px 16px',
                      backgroundColor: '#388e3c',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      fontSize: '13px',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s',
                      width: isMobile ? '100%' : 'auto'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#2e7d32'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#388e3c'}
                  >
                    Add More Teachers
                  </button>
                </div>
              )}
            </div>

            {/* Row 7: Mission LiFE Theme */}
            <div style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>Mission LiFE Theme / मिशन LiFE थीम</label>
              <input
                type="text"
                value="Save Water"
                className='form-control'
                style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                readOnly
                disabled
              />
            </div>

            {/* Row 8: Mission LiFE sub Theme - Activities as separate Yes/No containers with step-by-step flow */}
            <div style={{ marginBottom: '12px' }}>
              {/* Activity 1 - Always visible */}
              <div style={{
                marginBottom: '24px',
                padding: '20px',
                border: '2px solid #4CAF50',
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #f5fff5 0%, #ffffff 100%)',
                boxShadow: '0 2px 8px rgba(76, 175, 80, 0.15)',
                transition: 'all 0.3s ease'
              }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <div style={{
                    fontSize: '28px',
                    color: '#4CAF50',
                    minWidth: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#e8f5e9',
                    borderRadius: '8px'
                  }}>📢</div>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: 'block', marginBottom: '10px', fontWeight: 600, fontSize: '15px', color: '#2e7d32' }}>
                      Activity 1: Awareness campaign conducted by the school
                    </label>
                    <div style={{ fontSize: '12px', color: '#d32f2f', marginBottom: '12px', fontStyle: 'italic', fontWeight: 700 }}>
                      * One activity is compulsory to take
                    </div>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        padding: '8px 16px',
                        borderRadius: '6px',
                        background: activity1Selected === 'yes' ? '#4CAF50' : '#fff',
                        color: activity1Selected === 'yes' ? '#fff' : '#333',
                        border: '2px solid ' + (activity1Selected === 'yes' ? '#4CAF50' : '#ddd'),
                        transition: 'all 0.3s'
                      }}>
                        <input
                          ref={activity1Ref}
                          type="radio"
                          name="activity1"
                          value="yes"
                          checked={activity1Selected === 'yes'}
                          onChange={() => {
                            setActivity1Selected('yes');
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                        ✓ Yes
                      </label>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        padding: '8px 16px',
                        borderRadius: '6px',
                        background: activity1Selected === 'no' ? '#f44336' : '#fff',
                        color: activity1Selected === 'no' ? '#fff' : '#333',
                        border: '2px solid ' + (activity1Selected === 'no' ? '#f44336' : '#ddd'),
                        transition: 'all 0.3s'
                      }}>
                        <input
                          type="radio"
                          name="activity1"
                          value="no"
                          checked={activity1Selected === 'no'}
                          onChange={() => {
                            setActivity1Selected('no');
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                        ✗ No
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Activity 1 Form - Show immediately after selecting Yes for Activity 1 */}
            {activity1Selected === 'yes' && (
              <div style={{ marginTop: '30px' }}>
                <h3 style={{
                  color: '#2e7d32',
                  fontSize: isMobile ? '1.2rem' : '1.4rem',
                  fontWeight: 600,
                  margin: '0 0 24px 0'
                }}>Activity 1: Awareness campaign conducted by the school</h3>
                <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 24 }}>
                  {/* Left column: Lecture & Seminar */}
                  <div style={{ flex: 1 }}>
                    {/* 1. Lecture conducted */}
                    <div style={{ marginBottom: 24 }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>1) Was lecture conducted on water conservation / क्या जल संरक्षण पर व्याख्यान दिया गया था? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                      <select ref={lectureConductedRef} style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} value={lectureConducted} onChange={e => setLectureConducted(e.target.value)} required>
                        <option value="">Select</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                      {lectureConducted === "yes" && (
                        <>
                          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: '24px', marginTop: '12px' }}>
                            <div>
                              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>a) Number of experts participated?/ कितने विशेषज्ञों ने भाग लिया? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                              <input ref={lectureExpertsRef} type="number" placeholder="Number" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} required min="0" max="20000" title="Only numbers allowed" value={lectureExperts} onChange={e => setLectureExperts(e.target.value)} onInput={e => { if (e.target.value > 20000) e.target.value = 20000; }} />
                            </div>
                            <div>
                              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>b) Number of students participated?/ कितने छात्रों ने भाग लिया? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                              <input ref={lectureStudentsRef} type="number" placeholder="Number" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} required min="0" max="20000" title="Only numbers allowed" value={lectureStudents} onChange={e => setLectureStudents(e.target.value)} onInput={e => { if (e.target.value > 20000) e.target.value = 20000; }} />
                            </div>
                            <div>
                              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>c) Number of teachers participated?/ कितने शिक्षकों ने भाग लिया? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                              <input ref={lectureTeachersRef} type="number" placeholder="Number" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} required min="0" max="20000" title="Only numbers allowed" value={lectureTeachers} onChange={e => setLectureTeachers(e.target.value)} onInput={e => { if (e.target.value > 20000) e.target.value = 20000; }} />
                            </div>
                          </div>
                          <label style={{ marginTop: '14px', display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>d) Upload A geotagged photograph / भू-अभिचिह्नित (जियो-टैग्ड) फोटोग्राफ़ अपलोड करें <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                          {/* Preview uploaded lecture photos with delete button */}
                          {Array.isArray(lecturePhoto) && lecturePhoto.length > 0 && (
                            <div style={{ display: 'flex', gap: 16, marginBottom: 12, flexWrap: 'wrap' }}>
                              {lecturePhoto.map((photo, idx) => (
                                <div key={idx} style={{ position: 'relative', textAlign: 'center' }}>
                                  <a
                                    href={photo.processedFile ? URL.createObjectURL(photo.processedFile) : (photo.previewUrl || '#')}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={photo.processedFile ? URL.createObjectURL(photo.processedFile) : (photo.previewUrl || '')}
                                      alt=""
                                      style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 8, border: '1.5px solid #b2dfdb', marginBottom: 4 }}
                                    />
                                  </a>
                                  <div style={{ fontSize: 12, color: '#357a38' }}>View</div>
                                  {/* Remove button */}
                                  <button
                                    type="button"
                                    onClick={() => setLecturePhoto(prev => prev.filter((_, i) => i !== idx))}
                                    style={{
                                      position: 'absolute',
                                      top: -8,
                                      right: -8,
                                      background: '#f44336',
                                      color: '#fff',
                                      border: 'none',
                                      borderRadius: '50%',
                                      width: 24,
                                      height: 24,
                                      cursor: 'pointer',
                                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                      fontWeight: 'bold',
                                      fontSize: 16,
                                      lineHeight: '24px',
                                      padding: 0
                                    }}
                                    title="Remove photo"
                                  >
                                    ×
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                          {(!Array.isArray(lecturePhoto) || lecturePhoto.length < 3) && (
                            <input
                              ref={lecturePhotoRef}
                              type="file"
                              style={{ marginTop: 8, width: '100%' }}
                              accept="image/png,image/jpeg,image/jpg"
                              required={!lecturePhoto || lecturePhoto.length === 0}
                              multiple
                              onChange={e => handlePhotoUpload(e, setLecturePhoto, lecturePhoto)}
                            />
                          )}
                        </>
                      )}
                    </div>
                    {/* 2. Seminar conducted */}
                    <div style={{ marginBottom: 24 }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>2) Was Seminar conducted on water conservation / क्या जल संरक्षण पर सेमिनार आयोजित किया गया था? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                      <select ref={seminarConductedRef} style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} value={seminarConducted} onChange={e => setSeminarConducted(e.target.value)} required>
                        <option value="">Select</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                      {seminarConducted === "yes" && (
                        <>
                          <div style={{ marginBottom: '12px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>a) Topic of the Seminar/ सेमिनार का विषय <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                            <input
                              ref={seminarTopicRef}
                              type="text"
                              name="seminar_topic"
                              placeholder="Enter topic"
                              style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                              required
                              value={formState.seminar_topic}
                              onChange={handleInputChange}
                              pattern="^[A-Za-z ]+$"
                              title="Only alphabets allowed"
                              maxLength="400"
                              onInput={e => { if (e.target.value.length > 400) e.target.value = e.target.value.slice(0, 400); }}
                            />
                          </div>
                          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: '24px', marginTop: '12px' }}>
                            <div>
                              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>b) Number of experts participated?/ कितने विशेषज्ञों ने भाग लिया? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                              <input ref={seminarExpertsRef} type="number" placeholder="Number" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} required min="0" max="20000" title="Only numbers allowed" value={seminarExperts} onChange={e => setSeminarExperts(e.target.value)} onInput={e => { if (e.target.value > 20000) e.target.value = 20000; }} />
                            </div>
                            <div>
                              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>c) Number of students participated?/ कितने छात्रों ने भाग लिया? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                              <input ref={seminarStudentsRef} type="number" placeholder="Number" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} required min="0" max="20000" title="Only numbers allowed" value={seminarStudents} onChange={e => setSeminarStudents(e.target.value)} onInput={e => { if (e.target.value > 20000) e.target.value = 20000; }} />
                            </div>
                            <div>
                              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>d) Number of teachers participated?/ कितने शिक्षकों ने भाग लिया? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                              <input ref={seminarTeachersRef} type="number" placeholder="Number" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} required min="0" max="20000" title="Only numbers allowed" value={seminarTeachers} onChange={e => setSeminarTeachers(e.target.value)} onInput={e => { if (e.target.value > 20000) e.target.value = 20000; }} />
                            </div>
                          </div>
                          <label style={{ marginTop: '14px', display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>e) Upload A geotagged photograph / भू-अभिचिह्नित (जियो-टैग्ड) फोटोग्राफ़ अपलोड करें <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                          {/* Preview uploaded seminar photos with delete button */}
                          {Array.isArray(seminarPhoto) && seminarPhoto.length > 0 && (
                            <div style={{ display: 'flex', gap: 16, marginBottom: 12, flexWrap: 'wrap' }}>
                              {seminarPhoto.map((photo, idx) => (
                                <div key={idx} style={{ position: 'relative', textAlign: 'center' }}>
                                  <a
                                    href={photo.processedFile ? URL.createObjectURL(photo.processedFile) : (photo.previewUrl || '#')}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={photo.processedFile ? URL.createObjectURL(photo.processedFile) : (photo.previewUrl || '')}
                                      alt=""
                                      style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 8, border: '1.5px solid #b2dfdb', marginBottom: 4 }}
                                    />
                                  </a>
                                  <div style={{ fontSize: 12, color: '#357a38' }}>View</div>
                                  {/* Remove button */}
                                  <button
                                    type="button"
                                    onClick={() => setSeminarPhoto(prev => prev.filter((_, i) => i !== idx))}
                                    style={{
                                      position: 'absolute',
                                      top: -8,
                                      right: -8,
                                      background: '#f44336',
                                      color: '#fff',
                                      border: 'none',
                                      borderRadius: '50%',
                                      width: 24,
                                      height: 24,
                                      cursor: 'pointer',
                                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                      fontWeight: 'bold',
                                      fontSize: 16,
                                      lineHeight: '24px',
                                      padding: 0
                                    }}
                                    title="Remove photo"
                                  >
                                    ×
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                          {(!Array.isArray(seminarPhoto) || seminarPhoto.length < 3) && (
                            <input
                              ref={seminarPhotoRef}
                              type="file"
                              style={{ marginTop: 8, width: '100%' }}
                              accept="image/png,image/jpeg,image/jpg"
                              required={!seminarPhoto || seminarPhoto.length === 0}
                              multiple
                              onChange={e => handlePhotoUpload(e, setSeminarPhoto, seminarPhoto)}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  {/* Right column: Community & Other */}
                  <div style={{ flex: 1 }}>
                    {/* 3. Community awareness campaign */}
                    <div style={{ marginBottom: 24 }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>3) Was Community awareness campaign conducted on water conservation?/ क्या जल संरक्षण पर सामुदायिक जागरूकता अभियान चलाया गया था? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                      <select ref={communityConductedRef} style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} value={communityConducted} onChange={e => setCommunityConducted(e.target.value)} required>
                        <option value="">Select</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                      {communityConducted === "yes" && (
                        <>
                          <div style={{ marginBottom: '12px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>a) Please specify about the community awareness program (100 words)/ कृपया सामुदायिक जागरूकता कार्यक्रम के बारे में बताएं <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                            <input
                              ref={communityProgramRef}
                              type="text"
                              name="community_awareness_program"
                              placeholder="Enter description (100 words)"
                              style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                              required
                              value={formState.community_awareness_program}
                              onChange={e => {
                                const value = e.target.value;
                                const wordCount = value.trim().split(/\s+/).filter(Boolean).length;
                                if (wordCount <= 100) {
                                  handleInputChange(e);
                                }
                              }}
                              pattern="^[A-Za-z ]+$"
                              title="Only alphabets allowed"
                              maxLength="700"
                            />
                          </div>
                          <div style={{ color: (formState.community_awareness_program.trim().split(/\s+/).filter(Boolean).length > 100) ? 'red' : 'green', fontWeight: 500, marginTop: 4 }}>
                            {formState.community_awareness_program.trim().split(/\s+/).filter(Boolean).length} / 100 words
                            {formState.community_awareness_program.trim().split(/\s+/).filter(Boolean).length > 100 ? ' (Maximum 100 words)' : ''}
                          </div>
                        </>
                      )}
                    </div>
                    {/* 4. Other campaign */}
                    <div style={{ marginBottom: 24 }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>4) Any other kind of campaign?/ किसी भी अन्य प्रकार का अभियान? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                      <select ref={otherCampaignRef} style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} value={otherCampaign} onChange={e => setOtherCampaign(e.target.value)} required>
                        <option value="">Select</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                      {otherCampaign === "yes" && (
                        <>
                          <div style={{ marginBottom: '12px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>a) Please specify about the campaign / कृपया अभियान के बारे में बताएं <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                            <input
                              ref={otherCampaignSpecifyRef}
                              type="text"
                              name="other_campaign_specify"
                              placeholder="Enter campaign details"
                              style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                              required
                              value={formState.other_campaign_specify}
                              onChange={handleInputChange}
                              pattern="^[A-Za-z ]+$"
                              title="Only alphabets allowed"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Activity 2 - Always visible */}
            <div style={{ marginBottom: '12px' }}>
              <div style={{
                marginBottom: '24px',
                padding: '20px',
                border: '2px solid #2196F3',
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #f0f8ff 0%, #ffffff 100%)',
                boxShadow: '0 2px 8px rgba(33, 150, 243, 0.15)',
                transition: 'all 0.3s ease'
              }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <div style={{
                    fontSize: '28px',
                    color: '#2196F3',
                    minWidth: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#e3f2fd',
                    borderRadius: '8px'
                  }}>💧</div>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: 'block', marginBottom: '10px', fontWeight: 600, fontSize: '15px', color: '#1976d2' }}>
                      Activity 2: Water Conservation site(s) visited by the students
                    </label>
                    <div style={{ fontSize: '12px', color: '#d32f2f', marginBottom: '12px', fontStyle: 'italic', fontWeight: 700 }}>
                      * One activity is compulsory to take
                    </div>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        padding: '8px 16px',
                        borderRadius: '6px',
                        background: activity2Selected === 'yes' ? '#2196F3' : '#fff',
                        color: activity2Selected === 'yes' ? '#fff' : '#333',
                        border: '2px solid ' + (activity2Selected === 'yes' ? '#2196F3' : '#ddd'),
                        transition: 'all 0.3s'
                      }}>
                        <input
                          ref={activity2Ref}
                          type="radio"
                          name="activity2"
                          value="yes"
                          checked={activity2Selected === 'yes'}
                          onChange={() => {
                            setActivity2Selected('yes');
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                        ✓ Yes
                      </label>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        padding: '8px 16px',
                        borderRadius: '6px',
                        background: activity2Selected === 'no' ? '#f44336' : '#fff',
                        color: activity2Selected === 'no' ? '#fff' : '#333',
                        border: '2px solid ' + (activity2Selected === 'no' ? '#f44336' : '#ddd'),
                        transition: 'all 0.3s'
                      }}>
                        <input
                          type="radio"
                          name="activity2"
                          value="no"
                          checked={activity2Selected === 'no'}
                          onChange={() => {
                            setActivity2Selected('no');
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                        ✗ No
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Activity 2 Form - Show immediately after selecting Yes for Activity 2 */}
            {activity2Selected === 'yes' && (
              <div style={{ marginTop: '30px' }}>
                <h3 style={{
                  color: '#2e7d32',
                  fontSize: isMobile ? '1.2rem' : '1.4rem',
                  fontWeight: 600,
                  margin: '0 0 24px 0'
                }}>Activity 2: Water Conservation site(s) visited by the students</h3>
                <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 24 }}>
                  {/* Section 1 */}
                  <div style={{ flex: 1, minWidth: 320 }}>
                    <h6 style={{ fontSize: '16px', color: '#2e7d32', fontWeight: 600, marginBottom: '16px' }}>Section 1:</h6>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>a) Select Type of Site Visited/ भ्रमण किये गये स्थल का नाम <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                    <select ref={siteTypeRef} style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} value={activity2SiteType} onChange={e => setActivity2SiteType(e.target.value)} required>
                      <option value="">Select type</option>
                      <option value="bawdis">bawdis (stepwells)/ बावड़ी</option>
                      <option value="taals">taals (ponds)/ तालाब</option>
                      <option value="lakes">lakes/ झील</option>
                      <option value="other">Other:</option>
                    </select>
                    {activity2SiteType === "other" && (
                      <input type="text" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px', marginTop: '12px' }} placeholder="Other (specify)" value={activity2SiteTypeOther} onChange={e => setActivity2SiteTypeOther(e.target.value)} maxLength="400" onInput={e => { if (e.target.value.length > 400) e.target.value = e.target.value.slice(0, 400); }} />
                    )}
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>b) Name of visited site/ भ्रमण किए गए स्थल का नाम <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                    <input ref={siteNameRef} type="text" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} placeholder="Name of site" value={activity2SiteName} onChange={e => setActivity2SiteName(e.target.value)} required maxLength="400" onInput={e => { if (e.target.value.length > 400) e.target.value = e.target.value.slice(0, 400); }} />
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>c) In which state and district is the site located/ यह स्थल किस राज्य और जिले में स्थित है? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                    <select
                      style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px', marginBottom: '12px' }}
                      value={formState.site_state || ''}
                      onChange={e => {
                        setFormState(prev => ({ ...prev, site_state: e.target.value }));
                        setActivity2SiteDistrict(''); // Reset district when state changes
                      }}
                      required
                    >
                      <option value="" disabled>Select state</option>
                      {stateList.map(state => (
                        <option key={state.state_id} value={state.state_name}>{state.state_name}</option>
                      ))}
                    </select>
                    <select
                      ref={siteDistrictRef}
                      style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                      required
                      value={activity2SiteDistrict}
                      onChange={e => setActivity2SiteDistrict(e.target.value)}
                      disabled={!formState.site_state}
                    >
                      <option value="" disabled>{formState.site_state ? 'Select district' : 'Select state first'}</option>
                      {formState.site_state && getDistrictsByStateId(getStateIdByName(formState.site_state)).map(district => (
                        <option key={district.district_id} value={district.district_name}>{district.district_name}</option>
                      ))}
                    </select>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>d) Enter the city/town/village of the visited site/ देखी गई साइट का शहर/कस्बा/गांव दर्ज करें <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                    <input ref={siteCityRef} type="text" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} placeholder="City/Town/Village" value={activity2SiteCity} onChange={e => setActivity2SiteCity(e.target.value)} required maxLength="400" onInput={e => { if (e.target.value.length > 400) e.target.value = e.target.value.slice(0, 400); }} />
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>e) Number of students visited/ भ्रमण करने वाले विद्यार्थियों की संख्या <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                    <input ref={siteStudentsRef} type="number" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} placeholder="Number of students" value={activity2NumStudents} onChange={e => setActivity2NumStudents(e.target.value)} required min="0" max="20000" onInput={e => { if (e.target.value > 20000) e.target.value = 20000; }} />
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>f) Number of teachers visited/ भ्रमण करने वाले शिक्षकों की संख्या <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                    <input ref={siteTeachersRef} type="number" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} placeholder="Number of teachers" value={activity2NumTeachers} onChange={e => setActivity2NumTeachers(e.target.value)} required min="0" max="20000" onInput={e => { if (e.target.value > 20000) e.target.value = 20000; }} />
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>g) Upload A geotagged photograph / भू-अभिचिह्नित (जियो-टैग्ड) फोटोग्राफ़ अपलोड करें <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                    <input
                      ref={sitePhotoRef}
                      name="sitePhoto"
                      type="file"
                      style={{ marginTop: 8, width: '100%' }}
                      accept="image/png,image/jpeg,image/jpg"
                      multiple
                      required={!(Array.isArray(activity2Photo) && activity2Photo.length > 0)}
                      onChange={async e => {
                        const files = Array.from(e.target.files);
                        if (!files.length) return;
                        if (files.length + (Array.isArray(activity2Photo) ? activity2Photo.length : 0) > 3) {
                          toast.error('You can only upload up to 3 images.');
                          e.target.value = '';
                          return;
                        }
                        let validPhotos = Array.isArray(activity2Photo) ? [...activity2Photo] : [];
                        for (const file of files) {
                          try {
                            const result = await processGeotaggedImage(file);
                            validPhotos.push(result);
                          } catch (err) {
                            toast.error(err.message);
                          }
                        }
                        if (validPhotos.length > 3) validPhotos = validPhotos.slice(0, 3);
                        setActivity2Photo(validPhotos);
                        if (validPhotos.length) toast.success('Geotagged photo(s) validated and ready!');
                        e.target.value = '';
                      }}
                    />
                    {/* Preview uploaded sitevisit photos with delete button */}
                    {Array.isArray(activity2Photo) && activity2Photo.length > 0 && (
                      <div style={{ display: 'flex', gap: 16, marginTop: 12, flexWrap: 'wrap' }}>
                        {activity2Photo.map((photo, idx) => (
                          <div key={idx} style={{ position: 'relative', textAlign: 'center' }}>
                            <a
                              href={photo.processedFile ? URL.createObjectURL(photo.processedFile) : (photo.previewUrl || '#')}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={photo.processedFile ? URL.createObjectURL(photo.processedFile) : (photo.previewUrl || '')}
                                alt=""
                                style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 8, border: '1.5px solid #b2dfdb', marginBottom: 4 }}
                              />
                            </a>
                            <div style={{ fontSize: 12, color: '#357a38' }}>View</div>
                            {/* Remove button */}
                            <button
                              type="button"
                              onClick={() => setActivity2Photo(prev => prev.filter((_, i) => i !== idx))}
                              style={{
                                position: 'absolute',
                                top: -8,
                                right: -8,
                                background: '#f44336',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '50%',
                                width: 24,
                                height: 24,
                                cursor: 'pointer',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                fontWeight: 'bold',
                                fontSize: 16,
                                lineHeight: '24px',
                                padding: 0
                              }}
                              title="Remove photo"
                            >
                              ×
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {/* Section 2 */}
                  <div style={{ flex: 1, minWidth: 320 }}>
                    <h6 style={{ fontSize: '16px', color: '#2e7d32', fontWeight: 600, marginBottom: '16px' }}>Section 2:</h6>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>Does your area have any traditional water conservation structures?/ क्या आपके क्षेत्र में कोई पारंपरिक जल संरक्षण संरचनाएं हैं? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                    <select ref={hasTraditionalRef} style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} value={activity2HasTraditional} onChange={e => setActivity2HasTraditional(e.target.value)} required>
                      <option value="">Select</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                    {activity2HasTraditional === "yes" && (
                      <>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>a. Name of the Site/ स्थल का नाम <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                        <input ref={traditionalNameRef} type="text" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} placeholder="Name of the site" value={activity2TraditionalName} onChange={e => setActivity2TraditionalName(e.target.value)} required maxLength="400" onInput={e => { if (e.target.value.length > 400) e.target.value = e.target.value.slice(0, 400); }} />
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>b. Type of Structure/ संरचना का प्रकार <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                        <select ref={traditionalTypeRef} style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} value={activity2TraditionalType} onChange={e => setActivity2TraditionalType(e.target.value)} required>
                          <option value="">Select type</option>
                          <option value="bawdis">bawdis (stepwells)/ बावड़ी</option>
                          <option value="taals">taals (ponds)/ तालाब</option>
                          <option value="lakes">lakes/ झील</option>
                          <option value="other">Other:</option>
                        </select>
                        {activity2TraditionalType === "other" && (
                          <input type="text" style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px', marginTop: '12px' }} placeholder="Other (specify)" value={activity2TraditionalTypeOther} onChange={e => setActivity2TraditionalTypeOther(e.target.value)} maxLength="400" onInput={e => { if (e.target.value.length > 400) e.target.value = e.target.value.slice(0, 400); }} />
                        )}
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>c. Historical Background (up to 250 words) / ऐतिहासिक पृष्ठभूमि (अधिकतम 250 शब्दों में) <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                        <textarea ref={traditionalHistoryRef} style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} placeholder="Historical background" value={activity2TraditionalHistory} onChange={e => {
                          const value = e.target.value;
                          const wordCount = value.trim().split(/\s+/).filter(Boolean).length;
                          if (wordCount <= 250) setActivity2TraditionalHistory(value);
                        }} required maxLength={2000} rows={4} />
                        <div style={{ textAlign: 'left', marginTop: 6, marginBottom: 8, fontSize: '1em', fontWeight: 500, color: activity2TraditionalHistory.trim().split(/\s+/).filter(Boolean).length > 250 ? '#d32f2f' : '#388e3c' }}>
                          {activity2TraditionalHistory.trim().split(/\s+/).filter(Boolean).length} / 250 words
                          {activity2TraditionalHistory.trim().split(/\s+/).filter(Boolean).length > 250 ? ' (Maximum 250 words)' : ''}
                        </div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>d. Present Condition (Good / Fair / Poor) / वर्तमान स्थिति (अच्छी / सामान्य / खराब) <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                        <select ref={traditionalConditionRef} style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} value={activity2TraditionalCondition} onChange={e => setActivity2TraditionalCondition(e.target.value)} required>
                          <option value="">Select condition</option>
                          <option value="good">Good / अच्छी</option>
                          <option value="fair">Fair / ठीक-ठाक</option>
                          <option value="poor">Poor / खराब</option>
                        </select>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400', marginTop: '12px' }}>e. Any Restoration Work Done? / क्या कोई जीर्णोद्धार कार्य किया गया है? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span></label>
                        <select ref={restorationWorkRef} style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }} value={activity2RestorationWork} onChange={e => setActivity2RestorationWork(e.target.value)} required>
                          <option value="">Select</option>
                          <option value="yes">Yes / हाँ</option>
                          <option value="no">No / नहीं</option>
                        </select>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Activity 3 - Always visible */}
            <div style={{ marginBottom: '12px' }}>
              <div style={{
                marginBottom: '24px',
                padding: '20px',
                border: '2px solid #FF9800',
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #fff8f0 0%, #ffffff 100%)',
                boxShadow: '0 2px 8px rgba(255, 152, 0, 0.15)',
                transition: 'all 0.3s ease'
              }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <div style={{
                    fontSize: '28px',
                    color: '#FF9800',
                    minWidth: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#fff3e0',
                    borderRadius: '8px'
                  }}>🌊</div>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: 'block', marginBottom: '10px', fontWeight: 600, fontSize: '15px', color: '#f57c00' }}>
                      Activity 3: Ground Water Recharge System/Pit
                    </label>
                    <div style={{ fontSize: '12px', color: '#d32f2f', marginBottom: '12px', fontStyle: 'italic', fontWeight: 700 }}>
                      * One activity is compulsory to take
                    </div>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        padding: '8px 16px',
                        borderRadius: '6px',
                        background: activity3Selected === 'yes' ? '#FF9800' : '#fff',
                        color: activity3Selected === 'yes' ? '#fff' : '#333',
                        border: '2px solid ' + (activity3Selected === 'yes' ? '#FF9800' : '#ddd'),
                        transition: 'all 0.3s'
                      }}>
                        <input
                          ref={activity3Ref}
                          type="radio"
                          name="activity3"
                          value="yes"
                          checked={activity3Selected === 'yes'}
                          onChange={() => {
                            setActivity3Selected('yes');
                            setRechargeConstructed('yes');
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                        ✓ Yes
                      </label>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        padding: '8px 16px',
                        borderRadius: '6px',
                        background: activity3Selected === 'no' ? '#f44336' : '#fff',
                        color: activity3Selected === 'no' ? '#fff' : '#333',
                        border: '2px solid ' + (activity3Selected === 'no' ? '#f44336' : '#ddd'),
                        transition: 'all 0.3s'
                      }}>
                        <input
                          type="radio"
                          name="activity3"
                          value="no"
                          checked={activity3Selected === 'no'}
                          onChange={() => {
                            setActivity3Selected('no');
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                        ✗ No
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Activity 3 Form - Show immediately after selecting Yes for Activity 3 */}
            {activity3Selected === 'yes' && (
              <div style={{ marginTop: '30px' }}>
                <h3 style={{
                  color: '#2e7d32',
                  fontSize: isMobile ? '1.2rem' : '1.4rem',
                  fontWeight: 600,
                  margin: '0 0 24px 0'
                }}>Activity 3: Ground Water Recharge System/Pit</h3>

                {/* Ask: Was Ground Water Recharge System/Pit constructed? */}
                <div style={{ marginBottom: 24 }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>
                    Was Ground Water Recharge System/Pit constructed? / क्या भूजल पुनर्भरण प्रणाली/पिट का निर्माण किया गया था? <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span>
                  </label>
                  <select
                    ref={rechargeConstructedRef}
                    required
                    disabled={true}
                    style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                    value={rechargeConstructed}
                    onChange={e => setRechargeConstructed(e.target.value)}
                  >
                    <option value="" disabled>Select Yes or No</option>
                    <option value="yes">Yes / हाँ</option>
                    <option value="no">No / नहीं</option>
                  </select>
                </div>

                {/* Only show recharge details if constructed = yes */}
                {rechargeConstructed === "yes" && (
                  <>
                    {/* 1. Type of recharge system */}
                    <div style={{ marginBottom: 24 }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>
                        1) Please specify the type of Ground Water Recharge System constructed / कृपया बताएं कि किस प्रकार की भूजल पुनर्भरण प्रणाली का निर्माण किया गया है <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span>
                      </label>
                      <select
                        ref={rechargeTypeRef}
                        required
                        style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                        value={rechargeType}
                        onChange={e => {
                          const selected = rechargeTypeOptions.find(opt => opt.value === e.target.value);
                          setRechargeType(selected ? selected.label : "");
                        }}
                      >
                        <option value="" disabled>Select type</option>
                        {rechargeTypeOptions.map(opt => (
                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                      </select>
                    </div>
                    {/* 2. Location of recharge system */}
                    <div style={{ marginBottom: 24 }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>
                        2) Location of Ground Water Recharge System/Pit / सिस्टम/पिट का स्थान <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span>
                      </label>
                      <input
                        ref={rechargeLocationRef}
                        type="text"
                        required
                        style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                        value={rechargeLocation}
                        onChange={e => setRechargeLocation(e.target.value)}
                        placeholder="Enter location"
                        maxLength="400"
                        onInput={e => { if (e.target.value.length > 400) e.target.value = e.target.value.slice(0, 400); }}
                      />
                    </div>
                    {/* 3. Shape of recharge system */}
                    <div style={{ marginBottom: 24 }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>
                        3) Shape of Ground Water Recharge System/Pit / भूजल पुनर्भरण प्रणाली/पिट का आकार <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span>
                      </label>
                      <select
                        ref={rechargeShapeRef}
                        required
                        style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                        value={rechargeShape}
                        onChange={e => setRechargeShape(e.target.value)}
                      >
                        <option value="" disabled>Select shape</option>
                        <option value="circular">Circular / वृत्ताकार</option>
                        <option value="square">Square / वर्गाकार</option>
                        <option value="rectangular">Rectangular / आयताकार</option>
                      </select>
                    </div>
                    {/* 4. Volume of recharge system */}
                    <div style={{ marginBottom: 24 }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>
                        4) Volume (in cubic meters - m³) / आयतन (घन मीटर - m³) <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span>
                      </label>
                      <input
                        ref={rechargeVolumeRef}
                        type="number"
                        step="0.01"
                        required
                        style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                        value={rechargeVolume}
                        onChange={e => setRechargeVolume(e.target.value)}
                        placeholder="Enter volume in m³"
                        min="0"
                        max="20000"
                        onInput={e => { if (e.target.value > 20000) e.target.value = 20000; }}
                      />
                    </div>
                    {/* 5. Upload geotagged photo */}
                    <div style={{ marginBottom: 24 }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: '400' }}>
                        5) Upload A geotagged photograph / भू-अभिचिह्नित (जियो-टैग्ड) फोटोग्राफ़ अपलोड करें <span style={{ color: '#d32f2f', fontWeight: 800 }}>*</span>
                      </label>
                      <input
                        ref={rechargePhotoRef}
                        type="file"
                        accept="image/png,image/jpeg,image/jpg"
                        multiple
                        required={!(Array.isArray(rechargePhoto) && rechargePhoto.length > 0)}
                        style={{ width: '100%', padding: '10px', border: '2px solid #CAE769', borderRadius: '4px', fontSize: '14px' }}
                        onChange={e => handlePhotoUpload(e, setRechargePhoto, rechargePhoto)}
                      />
                      {/* Preview uploaded recharge photos (existing and new) with remove option */}
                      {Array.isArray(rechargePhoto) && rechargePhoto.length > 0 && (
                        <div style={{ display: 'flex', gap: 16, marginTop: 12 }}>
                          {rechargePhoto.map((photo, idx) => (
                            <div key={idx} style={{ textAlign: 'center', position: 'relative' }}>
                              {photo.previewUrl ? (
                                <a href={photo.previewUrl} target="_blank" rel="noopener noreferrer">
                                  <img
                                    src={photo.previewUrl}
                                    alt=""
                                    style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 8, border: '1.5px solid #b2dfdb', marginBottom: 4 }}
                                  />
                                </a>
                              ) : photo.processedFile ? (
                                <a href={URL.createObjectURL(photo.processedFile)} target="_blank" rel="noopener noreferrer">
                                  <img
                                    src={URL.createObjectURL(photo.processedFile)}
                                    alt=""
                                    style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 8, border: '1.5px solid #b2dfdb', marginBottom: 4 }}
                                  />
                                </a>
                              ) : null}
                              <div style={{ fontSize: 12, color: '#357a38' }}>View</div>
                              {/* Remove button */}
                              <button
                                type="button"
                                onClick={() => {
                                  setRechargePhoto(prev => prev.filter((_, i) => i !== idx));
                                }}
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  right: 0,
                                  background: '#fff',
                                  border: 'none',
                                  borderRadius: '50%',
                                  width: 22,
                                  height: 22,
                                  cursor: 'pointer',
                                  boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
                                  color: '#d32f2f',
                                  fontWeight: 'bold',
                                  zIndex: 2
                                }}
                                title="Remove photo"
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            )}

            <div style={{ marginTop: '18px', paddingTop: '10px', borderTop: '1px solid #e0e0e0' }}>
              <button type="submit" style={{
                marginTop: 0,
                background: '#2e7d32',
                color: '#fff',
                border: 'none',
                padding: isMobile ? '8px 18px' : '8px 22px',
                borderRadius: '6px',
                fontWeight: 600,
                fontSize: isMobile ? '0.98rem' : '1rem',
                cursor: 'pointer',
                boxShadow: '0 2px 4px rgba(0,0,0,0.13)',
                transition: 'background 0.3s',
              }}
                onMouseEnter={(e) => e.target.style.background = '#1b5e20'}
                onMouseLeave={(e) => e.target.style.background = '#2e7d32'}
              >SUBMIT</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RasActivitiesForm;
